import { createSelector } from "@ngrx/store";

import * as fromRoot from "#core/router-store";
import * as fromFeature from "../reducers";
import * as fromSchools from "../reducers/schools.reducer";

// get schools state
export const getSchoolsState = createSelector(
    fromFeature.getCoursesModuleState,
    (state: fromFeature.CoursesState) => state.schools
);

// get school entities
export const getSchoolsEntities = createSelector(
    getSchoolsState,
    fromSchools.getSchoolsEntities
);

// convert Entities so view can consume
export const getSchools = createSelector(
    getSchoolsEntities,
    entities => {
        return Array.from(entities.values());
    }
);

export const getTeacherSchoolsIDs = createSelector(
    getSchoolsState,
    fromSchools.getTeacherSchools
);

export const getTeacherSchools = createSelector(
    getTeacherSchoolsIDs,
    passportSchoolIDs => {
        return Array.from(passportSchoolIDs.values());
    }
);

export const getSchoolsLoaded = createSelector(
    getSchoolsState,
    fromSchools.getSchoolsLoaded
);

export const getSchoolsLoading = createSelector(
    getSchoolsState,
    fromSchools.getSchoolsLoading
);

export const getRawSchoolsResponse = createSelector(
    getSchoolsState,
    fromSchools.getRawSchoolsResponse
);

// export const getSchoolPaginationParams = createSelector(
//     getSchoolsState,
//     fromSchools.getPaginationParams
// );

export const getSchoolFidoStudentsEntities = createSelector(
    getSchoolsState,
    fromSchools.getSchoolFidoStudentsEntities
);
export const getSchoolFidoStudents = createSelector(
    getSchoolFidoStudentsEntities,
    entities => {
        return Array.from(entities.values());
    }
);
